import React, { memo, useEffect } from "react";
import { AlertDialog } from "../common/AlertDailog";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useStudies } from "../../hooks/useStudies";
import { useNavigate } from "react-router-dom";
import { useAppSelector, AppState, useAppDispatch } from "../../store";
import { setOpenDeleteStudyDialog } from "../../store/slices/studiesSlice";

const DeleteStudyDialog: React.FunctionComponent<any> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { showSuccess, handleError } = useSnackbar();
  const openDeleteStudyDialog = useAppSelector(
    (state: AppState) => state.studiesSlice.openDeleteStudyDialog
  );
  const selectedStudy = useAppSelector(
    (state: AppState) => state.studiesSlice.selectedStudy
  );
  const {
    deleteStudy,
    deleteStudyData,
    deleteStudyIsError,
    deleteStudyError,
    deleteStudyIsSuccess,
  } = useStudies();

  const handleCloseDeleteStudy = () => {
    dispatch(setOpenDeleteStudyDialog(false));
  };
  const handleDeleteStudy = () => {
    deleteStudy({ study_id: selectedStudy });
  };
  useEffect(() => {
    if (deleteStudyIsSuccess) {
      const successMsg = deleteStudyData;
      showSuccess(successMsg?.details, "study-delete-success");
      navigate("/studies");
      handleCloseDeleteStudy();
    }
  }, [deleteStudyIsSuccess]);
  useEffect(() => {
    if (deleteStudyIsError) {
      const errorMsg: any = deleteStudyError;
      handleError(errorMsg);
    }
  }, [deleteStudyIsError]);
  return (
    <>
      <AlertDialog
        open={openDeleteStudyDialog}
        title="Delete Study"
        description={`Are you sure you want to delete the study <strong>${selectedStudy}</strong>?`}
        handleClose={handleCloseDeleteStudy}
        handleConfirm={handleDeleteStudy}
        confirmBtn="Yes"
        cancelBtn="No"
        maxWidth="xs"
      />
    </>
  );
};

export default memo(DeleteStudyDialog);
